@if (stakingProcess$ | async; as stakingProcess) {
  <div class="amount-rect">
    <img
      class="pr-15 image-size"
      [src]="stakingProcess.stakeable?.id | assetIcon"
      alt="{{ 'logo_alt_text' | translate }}" />
    <div class="staking-summary-amounts">
      <span>{{
        (stakingProcess.type === stakingType.STAKE ? "staking_amount" : "unstaking_amount") | translate
      }}</span>
      <div class="staking-summary-amounts__values">
        <span class="staking-tradable-amount pr-15">{{
          stakingProcess.amountType === tradeAmountTypes.ASSET
          ? (stakingProcess.amount
          | tradable_precision_symbol: { id: stakingProcess.stakeable?.id, symbol: true })
          : (stakingProcess.amount
          | fiat_precision_symbol
          : { id: defaultFiat.getId(), currencies: [defaultFiat], symbol: true })
        }}</span>
        <span class="staking-fiat-amount">{{
          stakingProcess.amountType === tradeAmountTypes.ASSET
          ? (stakingProcess.amount
          | convert_tradable_to_fiat: stakingProcess.stakeable?.id
          | fiat_precision_symbol
          : { id: defaultFiat.getId(), currencies: [defaultFiat], symbol: true })
          : (stakingProcess.amount
          | convert_fiat_to_tradable: stakingProcess.stakeable?.id
          | tradable_precision_symbol: { id: stakingProcess.stakeable?.id, symbol: true })
        }}</span>
      </div>
    </div>
  </div>
  <ng-content></ng-content>
  <!-- Performance indicator needed for UK -->
	<div class="font-size-13 pb-30 text-gray">
		{{ "performance_indicators_7_days_timeframe" | translate }}
	</div>
  <!-- dynamic terms -->
  <terms-and-conditions-updates [bundles]="bundles$ | async" [tradable]="tradable"></terms-and-conditions-updates>
}
